import { createFileRoute } from '@tanstack/react-router';
import { KpiModule } from '@/modules/kpi';

export const Route = createFileRoute('/(dashboard)/_dashboard/performance-review/$id')({
  component: KpiModule,
});
